import DOMPurify from "dompurify";

/**
 * Sanitizace HTML, které vyrenderoval server (nápověda, changelog).
 *
 * Proč vlastní modul místo holého `DOMPurify.sanitize`: **výchozí allowlist atributů
 * `target` neobsahuje**, takže odkazy, kterým server v `DocsHtmlPostProcessor` dopsal
 * `target="_blank"`, o něj cestou do DOM přišly. Klik na Swagger UI pak odnavigoval
 * celý panel z aplikace pryč a uživatel přišel o rozdělanou práci. Chyba byla o to
 * hůř vidět, že `rel="noopener"` na allowlistu je, takže v DOM zůstal.
 *
 * Hook doplňuje `rel` sám: `target="_blank"` bez `noopener` dává otevřené stránce
 * přístup k `window.opener`. Nespoléháme na to, že ho dopsal server — tahle funkce je
 * poslední místo před vložením do stránky.
 */
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node instanceof Element && node.getAttribute("target") === "_blank") {
        node.setAttribute("rel", "noopener noreferrer");
    }
});

/** Vyčistí server HTML a zachová `target` na odkazech. */
export function sanitizeServerHtml(html: string): string {
    return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
}
